import { c as _c } from "react/compiler-runtime";
import { css } from '@repo/pandacss/css';
import { Grid } from '@repo/pandacss/jsx';
import { token } from '@repo/pandacss/tokens';
import type { CSSProperties } from 'react';
import { type ApprovalOddsValues, Likelihood } from '@/features/approval-odds/constants';
import { CardsApprovalLabel } from './CardsApprovalLabel';
import { APPROVAL_ODDS_CSS_VARS, approvalLabelGridClass, approvalOddsSlotRecipe } from './styles';
const times = <T,>(n: number, fn: (i: number) => T): T[] => Array.from({
  length: n
}, (_, i) => fn(i));
const emptyLineColor = token.var('colors.grey.200');
const lineFillVar = `var(${APPROVAL_ODDS_CSS_VARS.labelColor})`;
type ApprovalLineSectionProps = {
  halfWay: boolean;
  isFilled: boolean;
};
const lineSectionClass = css({
  display: 'inline-block',
  height: '[6px]',
  width: '[100%]',
  gridRow: '2'
});
function lineSectionStyle(isFilled: boolean, halfWay: boolean): CSSProperties {
  if (!isFilled) {
    return {
      background: emptyLineColor
    };
  }
  if (!halfWay) {
    return {
      background: lineFillVar
    };
  }
  return {
    background: `linear-gradient(90deg, ${lineFillVar} 50%, ${emptyLineColor} 50%)`
  };
}
const ApprovalLineSection = t0 => {
  const $ = _c(5);
  const {
    isFilled,
    halfWay
  } = t0;
  let t1;
  if ($[0] !== halfWay || $[1] !== isFilled) {
    t1 = lineSectionStyle(isFilled, halfWay);
    $[0] = halfWay;
    $[1] = isFilled;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t1) {
    t2 = <div data-testid="approval-line-section" className={lineSectionClass} style={t1} />;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
};
export type CardsApprovalLineProps = {
  approvalLikelihood: ApprovalOddsValues | null;
};
export const CardsApprovalLine = t0 => {
  const $ = _c(13);
  const {
    approvalLikelihood
  } = t0;
  const isPoor = approvalLikelihood?.label === Likelihood.Poor;
  const t1 = approvalLikelihood?.label ?? undefined;
  let t2;
  if ($[0] !== t1) {
    t2 = approvalOddsSlotRecipe({
      likelihood: t1
    });
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const {
    labelContainer
  } = t2;
  let t3;
  if ($[2] !== approvalLikelihood?.label) {
    t3 = approvalLikelihood?.label && <CardsApprovalLabel label={approvalLikelihood?.label} />;
    $[2] = approvalLikelihood?.label;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== labelContainer || $[5] !== t3) {
    t4 = <Grid columns={5} columnGap="1" className={approvalLabelGridClass}><div className={labelContainer}>{t3}</div></Grid>;
    $[4] = labelContainer;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== approvalLikelihood?.placement || $[8] !== isPoor) {
    t5 = times(5, idx => <ApprovalLineSection key={idx} halfWay={!isPoor && idx === (approvalLikelihood?.placement ?? 0) - 1} isFilled={idx < (approvalLikelihood?.placement ?? 0)} />);
    $[7] = approvalLikelihood?.placement;
    $[8] = isPoor;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t4 || $[11] !== t5) {
    t6 = <>{t4}{t5}</>;
    $[10] = t4;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  return t6;
};